import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=6973375a&scoped=true&"
import script from "./payment.vue?vue&type=script&lang=js&"
export * from "./payment.vue?vue&type=script&lang=js&"
import style0 from "./payment.vue?vue&type=style&index=0&id=6973375a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6973375a",
  null
  
)

export default component.exports